import * as React from "react";
import { Navigate, Routes, Route } from "react-router";

export default function Pair(): React.JSX.Element {
    return (
        <Routes>
            <Route path="" element={<Navigate replace to="/" />} />
            <Route path="select" element={<Navigate replace to="/" />} />
        </Routes>
    );
}
